import { errorLogger } from "./error-logger";
import { COMPANY_ABBR } from "../common/constants/company";

export type TryCatchResult<T> =
    | { success: true; data: T }
    | { success: false; error: string };

export const TryCatch = async <T>(asyncFn: () => Promise<T>): Promise<TryCatchResult<T>> => {
    try {
        const data = await asyncFn();
        return { success: true, data };
    } catch (e) {
        const error = e as any;
        const _status = error?.response?.status ?? "status";
        const errorMessage = `${_status}: ` + error?.response?.data || error?.message || 'Error unknown';
        //ToDo: �����������
        console.error(errorMessage);
        const errorLog = {
            projectName: COMPANY_ABBR,
            errorMessage: errorMessage,
            errorDate: new Date()
        }
        await errorLogger(errorLog)
        return { success: false, error: errorMessage };
    }
};

export const TryCatchReject = async <T>(asyncFn: () => Promise<T>, rejectWithValue: (value: string) => any): Promise<T | ReturnType<typeof rejectWithValue>> => {
    try {
        return await asyncFn();
    } catch (e) {
        const error = e as any;
        const errorMessage = error?.response?.data || error?.message || 'Error unknown';
        //ToDo: �����������
        console.error(errorMessage);
        const errorLog = {
            projectName: COMPANY_ABBR,
            errorMessage: errorMessage,
            errorDate: new Date()
        }
        await errorLogger(errorLog)
        return rejectWithValue(errorMessage);
    }
};

interface TryCatchOptions {
    retries?: number;
    delayMs?: number;
    context?: string;
}

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const TryCatchRateLimit = async <T>(asyncFn: () => Promise<T>, options: TryCatchOptions = {}): Promise<TryCatchResult<T>> => {
    const { retries = 2, delayMs = 1000, context = '������' } = options;

    for (let attempt = 0; attempt <= retries; attempt++) {
        try {
            const data = await asyncFn();
            return { success: true, data };
        } catch (e) {
            const error = e as any;
            const status = error?.response?.status;
            const errorMessage = error?.response?.data || error?.message || '����������� ������';

            console.warn(`${context} [������� ${attempt + 1}]:`, errorMessage);

            if (status === 429 && attempt < retries) {
                console.info(`������� 429. ��� ${delayMs} �� ����� ��������...`);
                await sleep(delayMs);
                continue;
            }

            return { success: false, error: errorMessage };
        }
    }

    return { success: false, error: '�� ������� ��������� ������ ����� ��������' };
};
/** ������ ������������� TryCatchRateLimit
 * const result = await TryCatchRateLimit(
 *     () => api.post(API_REGISTRATION, payload).then(res => res.data),
 *     { retries: 3, delayMs: 1500, context: '�����������' }
 * );
*/